import React from "react"
import { Box, TextField, useTheme, ThemeProvider, Typography } from "@mui/material"
import { ICustomFieldTemplate } from "../../entities/job/interface"

interface Props {
    field: ICustomFieldTemplate
    value: string
    error?: string
    onChange: (id: string, value: string) => void
    isEditable: boolean
    type: string
}

const TextComponent: React.FC<Props> = ({ field, value, error, onChange, isEditable, type }) => {
    const theme = useTheme()
    return (
        <ThemeProvider theme={theme}>
            <Box>
                <TextField
                    value={value || ""}
                    placeholder={value || "Enter value"}
                    onChange={(e) => onChange(field.customFieldTemplateId, e.target.value)}
                    error={!!error}
                    disabled={!isEditable}
                    type={type === "NUMBER" ? "number" : "text"}
                    style={{
                        backgroundColor: "#027BBA",
                        color: "white",
                        borderRadius: "10px",
                        padding: "10px",
                    }}
                    fullWidth
                    sx={{
                        fontSize: "18px",
                        color: "white",
                        "& .MuiInputBase-root": {
                            color: "white",
                            height: 30,
                            fontSize: "15px",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "none",
                            border: "0px",
                        },
                        "& .MuiPickersModal-root": {
                            color: "white",
                            width: "100%",
                        },
                        "& .MuiOutlinedInput-root .MuiInputBase-input::placeholder": {
                            color: "white",
                        },
                    }}
                />
                <Typography variant="caption" color="error" fontSize={"15px"}>
                    {error}
                </Typography>
            </Box>
        </ThemeProvider>
    )
}

export default TextComponent
